import React, { Component, createRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import recaptchaSiteKey from '../utils';

class Captcha extends Component {
  constructor(props) {
    super(props);
    this.recaptchaRef = createRef();
    this.state = {
      isRecaptchaVerified: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.requestRecaptchaReset !== this.props.requestRecaptchaReset) {
      this.recaptchaRef.current.reset();
      this.setState({ isRecaptchaVerified: false });
    }

    if (prevState.isRecaptchaVerified !== this.state.isRecaptchaVerified) {
      const recaptchaToken = this.recaptchaRef.current.getValue();
      this.props.onRecaptchaVerifiedChanged(this.state.isRecaptchaVerified);
      this.props.onRecaptchaTokenChanged(recaptchaToken);
    }
  }

  handleChange = () => {
    this.setState({ isRecaptchaVerified: true });
  }

  handleExpired = () => {
    this.setState({ isRecaptchaVerified: false });
  }

  render() {
    const { className } = this.props;

    return (
      <ReCAPTCHA
        className={className}
        sitekey={recaptchaSiteKey}
        onChange={this.handleChange}
        onExpired={this.handleExpired}
        ref={this.recaptchaRef}
      />
    );
  }
}

export default Captcha;
